import { Container, Grid } from '@mui/material';
import React from 'react';
import LogsTable from '../components/logs-management/LogsTable';

const LogsPage = () => {
  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 4 }}>
        <Grid container spacing={2}>
          <Grid item md={12}>
            <LogsTable />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default LogsPage;
